import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class checkNAddEmailUseCase extends BaseUseCase {
    constructor(loginRepo) {
        super();
        this.loginRepo = loginRepo;
    }
    async fetchResult(data) {
        return await this.loginRepo.checkNAddEmail(data);
    }
}
export default checkNAddEmailUseCase;
